(() => {
  const gateway = document.querySelector(
    '[data-cs-shop-gateway]'
  );
  const shop = document.querySelector(
    '[data-cs-shop]'
  );

  if (!gateway) return;

  const params = new URLSearchParams(
    window.location.search
  );
  const skipGateway =
    params.get('gateway') === 'skip';

  gateway.hidden = skipGateway;

  if (shop) {
    shop.hidden = !skipGateway;
  }

  gateway
    .querySelectorAll('[data-cs-shop-path]')
    .forEach((link) => {
      link.addEventListener('click', () => {
        const context = {
          shoppingPath:
            link.dataset.csShopPath || '',
          fulfillmentHandle:
            link.dataset.csFulfillmentHandle || '',
          savedAt: Date.now(),
        };

        try {
          sessionStorage.setItem(
            'coldSugarShoppingContext',
            JSON.stringify(context)
          );
        } catch (error) {
          console.warn(
            'Cold Sugar shopping context could not be saved.',
            error
          );
        }
      });
    });

  const configElement = gateway.querySelector(
    '[data-cs-shop-gateway-config]'
  );

  let config = {};

  try {
    config = JSON.parse(
      configElement?.textContent || '{}'
    );
  } catch (error) {
    console.warn(
      'Cold Sugar gateway status could not be calculated.',
      error
    );
    return;
  }

  function list(value) {
    if (Array.isArray(value)) {
      return value
        .map(String)
        .map((item) => item.trim())
        .filter(Boolean);
    }

    return String(value || '')
      .split(/\r?\n|,/)
      .map((item) => item.trim())
      .filter(Boolean);
  }

  function isoDate(date) {
    return [
      date.getUTCFullYear(),
      String(
        date.getUTCMonth() + 1
      ).padStart(2, '0'),
      String(
        date.getUTCDate()
      ).padStart(2, '0'),
    ].join('-');
  }

  function parseISO(value) {
    const match = String(value || '').match(
      /^(\d{4})-(\d{2})-(\d{2})$/
    );

    if (!match) return null;

    return new Date(
      Date.UTC(
        Number(match[1]),
        Number(match[2]) - 1,
        Number(match[3])
      )
    );
  }

  function addDays(date, days) {
    const next = new Date(date.getTime());
    next.setUTCDate(
      next.getUTCDate() + days
    );
    return next;
  }

  function atTime(date, value) {
    const [hour, minute] = String(
      value || '00:00'
    )
      .split(':')
      .map(Number);

    return new Date(
      Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        hour || 0,
        minute || 0
      )
    );
  }

  function zonedNow() {
    const parts = new Intl.DateTimeFormat(
      'en-US',
      {
        timeZone:
          config.timeZone ||
          'America/Chicago',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23',
      }
    ).formatToParts(new Date());

    const values = {};

    parts.forEach((part) => {
      if (part.type !== 'literal') {
        values[part.type] =
          Number(part.value);
      }
    });

    return new Date(
      Date.UTC(
        values.year,
        values.month - 1,
        values.day,
        values.hour,
        values.minute,
        values.second
      )
    );
  }

  function weekdays(value) {
    const map = {
      sunday: 0,
      monday: 1,
      tuesday: 2,
      wednesday: 3,
      thursday: 4,
      friday: 5,
      saturday: 6,
    };

    return list(value)
      .map((item) =>
        map[
          item
            .toLowerCase()
            .replace(/s$/, '')
        ]
      )
      .filter(Number.isInteger);
  }

  function allowed(date) {
    const porch = config.porch || {};
    const allowedDays = weekdays(
      porch.activeWeekdays || 'thursday'
    );
    const start = parseISO(
      porch.startDate
    );
    const end = parseISO(
      porch.endDate
    );

    if (
      allowedDays.length &&
      !allowedDays.includes(
        date.getUTCDay()
      )
    ) {
      return false;
    }

    if (start && date < start) {
      return false;
    }

    if (end && date > end) {
      return false;
    }

    return true;
  }

  function nextEvent(today) {
    const override = parseISO(
      config.porch?.eventDateOverride
    );

    if (
      override &&
      override >= today
    ) {
      return override;
    }

    for (
      let offset = 0;
      offset <= 42;
      offset += 1
    ) {
      const candidate = addDays(
        today,
        offset
      );

      if (allowed(candidate)) {
        return candidate;
      }
    }

    return addDays(today, 7);
  }

  function resolveStatus() {
    const now = zonedNow();

    const today = new Date(
      Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate()
      )
    );

    let eventDate = nextEvent(today);

    let reset = atTime(
      eventDate,
      config.porch?.resetTime || '22:00'
    );

    if (now >= reset) {
      eventDate = nextEvent(
        addDays(eventDate, 1)
      );

      reset = atTime(
        eventDate,
        config.porch?.resetTime || '22:00'
      );
    }

    const liveOpen = atTime(
      eventDate,
      config.porch?.liveOpenTime ||
        '15:00'
    );

    const liveClose = atTime(
      eventDate,
      config.porch?.liveCloseTime ||
        '19:00'
    );

    const cancelledFlag =
      config.porch?.eventCancelled === true ||
      String(
        config.porch?.eventCancelled
      ).toLowerCase() === 'true';

    const cancellationDate = parseISO(
      config.porch?.eventCancelledDate
    );

    const blockedCancellation =
      list(config.porch?.blockedDates).includes(
        isoDate(eventDate)
      );

    const cancelled =
      blockedCancellation ||
      (
        cancelledFlag &&
        (
          !cancellationDate ||
          isoDate(cancellationDate) ===
            isoDate(eventDate)
        )
      );

    const menuReady = !(
      config.porch?.menuReady === false ||
      String(
        config.porch?.menuReady
      ).toLowerCase() === 'false'
    );

    if (cancelled) {
      return 'cancelled';
    }

    if (
      now >= liveClose &&
      now < reset
    ) {
      return 'ended';
    }

    if (
      now >= liveOpen &&
      now < liveClose
    ) {
      return 'live';
    }

    if (!menuReady) {
      return 'preparing';
    }

    if (
      isoDate(today) ===
      isoDate(eventDate)
    ) {
      return 'countdown';
    }

    return 'upcoming';
  }

  const state = resolveStatus();

  const porchStatus =
    gateway.querySelector(
      '[data-cs-gateway-porch-status]'
    );

  const porchButton =
    gateway.querySelector(
      '[data-cs-gateway-porch-button]'
    );

  const labels = {
    cancelled: [
      'Unavailable this week',
      'See schedule details',
    ],
    ended: [
      'Closed for tonight',
      'See next Thursday',
    ],
    live: [
      'Open now',
      'Shop the porch',
    ],
    countdown: [
      'Opens at 3 PM',
      'See today’s Porch Shop',
    ],
    preparing: [
      'Menu being prepared',
      'See Thursday details',
    ],
    upcoming: [
      'Thursday 3–7 PM',
      'See this week’s Porch Shop',
    ],
  };

  const [
    statusLabel,
    buttonLabel,
  ] =
    labels[state] ||
    labels.upcoming;

  if (porchStatus) {
    porchStatus.textContent =
      statusLabel;
  }

  if (porchButton) {
    porchButton.textContent =
      buttonLabel;

    porchButton.dataset.csShopPath =
      'porch_live';
  }
})();
